import React, { FC } from "react";
import { StyledQuantity, StyledQuantityWrapper } from "./index.styled";

interface QuantityIndicatorProps {
  quantity: number;
}

export const QuantityIndicator: FC<QuantityIndicatorProps> = ({ quantity }) => (
  <div>
    <StyledQuantityWrapper>
      <StyledQuantity>{quantity}</StyledQuantity>
    </StyledQuantityWrapper>
  </div>
);
